import React from 'react';
import logoDefault from "assets/logo.svg";
import isoDefault from "assets/isotype.svg";
import { getAppName } from 'utils/utils';
import { isHaddockHostname } from 'utils/haddockDomain';

const Logo = ({ type = "logo", className = "" }) => {
  const domain = window.location.hostname;

  if (!isHaddockHostname(domain)) {
    const defaultImage = type === "iso" ? isoDefault : logoDefault;
    return <img className={className} src={defaultImage} alt={`Logo ${getAppName()}`} />;
  }

  // Para el resto de skins, usamos rutas dinámicas
  const logoPath = `/haddock/logo.svg`;
  const isoPath = `/haddock/isotype.svg`;

  const imagePath = type === "iso" ? isoPath : logoPath;
  const fallback = type === "iso" ? isoDefault : logoDefault;

  return (
    <img
      className={className}
      src={imagePath}
      onError={(e) => {
        if (e.target.src !== fallback) {
          e.target.src = fallback;
        }
      }}
      alt={`Logo ${getAppName()}`}
    />
  );
};

export default React.memo(Logo);
